import Vue from "vue";
import Router from "vue-router";
import Home from "./components/Home.vue";

Vue.use(Router);

export default new Router({
	scrollBehavior() {
		return { x: 0, y: 0 };
	}, // Qdo clica em um link de página interna, vai para o topo da página
	routes: [
		{
			path: "/",
			name: "Home",
			component: Home
		},
		{
			path: "/catalogo",
			name: "catalogo",
			component: () => import("./components/Catalogo.vue")
		},
		{
				path: "/flippingbook",
				name: "flippingbook",
				component: () => import("./components/Flippingbook.vue")
		}
	],
	mode: 'history' // Remove # da URL
})
